import { shallowRef } from 'vue';
import type { RouteRecordRaw } from 'vue-router';

import type { Module } from '@utils/model';

import { PAGES } from './constants';

import ModuleIcon from '~icons/eos-icons/ai-operator';

const routes: RouteRecordRaw[] = [
	{
		path: '/mlops-manager',
		name: PAGES.HOME,
		component: () => import('./pages/index.vue'),
		meta: {
			documentTitle: 'MLOps Manager',
			title: 'MLOps Manager',
			subtitle: 'Models',
		},
		children: [
			{
				path: '',
				name: PAGES.MODELS_LIST,
				component: () => import('./pages/Models/index.vue'),
				meta: {
					documentTitle: 'MLOps Manager / Models',
					title: 'MLOps Manager',
					subtitle: 'Models',
				},
			},
			{
				path: 'create',
				name: PAGES.MODEL_CREATE,
				component: () => import('./pages/ModelCreate/index.vue'),
				meta: {
					documentTitle: 'MLOps Manager / Model Create',
					title: 'MLOps Manager',
					subtitle: 'Model / Create',
				},
			},
			{
				path: 'predictions',
				name: PAGES.PREDICTIONS,
				component: () => import('./pages/Predictions/index.vue'),
				meta: {
					documentTitle: 'MLOps Manager / Predictions',
					title: 'MLOps Manager',
					subtitle: 'Predictions',
				},
			},
			{
				path: ':slug',
				name: PAGES.MODEL_DETAILS,
				component: () => import('./pages/ModelDetails/index.vue'),
				props: true,
				meta: {
					documentTitle: 'MLOps Manager / Model Details',
					title: 'MLOps Manager',
					subtitle: 'Model / Details',
				},
			},
			{
				path: ':slug/:version(\\d+)/tests/:testId(\\d+)',
				name: PAGES.MODEL_TEST_DETAILS,
				component: () => import('./pages/TestDetails/index.vue'),
				props: true,
				meta: {
					documentTitle: 'MLOps Manager / Test Details',
					title: 'MLOps Manager',
					subtitle: 'Test / Details',
				},
			},
			{
				path: 'predictions/:id(\\d+)',
				name: PAGES.PREDICTION_DETAILS,
				component: () => import('./pages/PredictionDetails/index.vue'),
				props: true,
				meta: {
					documentTitle: 'MLOps Manager / Prediction Details',
					title: 'MLOps Manager',
					subtitle: 'Prediction / Details',
				},
			},
			{
				path: 'image-predictions',
				name: PAGES.IMAGE_PREDICTIONS,
				component: () => import('./pages/ImagePredictions/index.vue'),
				props: true,
				meta: {
					documentTitle: 'MLOps Manager / Image Predictions',
					title: 'MLOps Manager',
					subtitle: 'Images Predictions',
				},
			},
			{
				path: 'image-predictions/:imageId',
				name: PAGES.IMAGE_PREDICTION_DETAILS,
				component: () => import('./pages/ImagePredictionDetails/index.vue'),
				props: true,
				meta: {
					documentTitle: 'MLOps Manager / Image Predictions / Details',
					title: 'MLOps Manager',
					subtitle: 'Image Predictions / Details',
				},
			},
			{
				path: 'pipelines',
				name: PAGES.PIPELINES,
				component: () => import('./pages/PipelinesV3/index.vue'),
				props: true,
				meta: {
					documentTitle: 'MLOps Manager / Pipelines',
					title: 'MLOps Manager',
					subtitle: 'Pipelines',
				},
			},
			{
				path: 'pipelines/:name([a-z-.]+)',
				name: PAGES.PIPELINE_DETAILS,
				component: () => import('./pages/PipelineDetailsV3/index.vue'),
				props: true,
				meta: {
					documentTitle: 'MLOps Manager / Pipelines / Details',
					title: 'MLOps Manager',
					subtitle: 'Pipelines / Details',
				},
			},
			{
				path: 'pipelines/callllm-versions',
				name: PAGES.PIPELINE_VERSIONS,
				component: () => import('./pages/PipelinesVersionsV3/index.vue'),
				props: true,
				meta: {
					documentTitle: 'MLOps Manager / Pipelines / CallLlm Versions',
					title: 'MLOps Manager',
					subtitle: 'Pipelines / CallLlm Versions',
				},
			},
			{
				path: 'settings',
				name: PAGES.SETTINGS,
				component: () => import('./pages/Settings/index.vue'),
				props: true,
				meta: {
					documentTitle: 'MLOps Manager / Settings',
					title: 'MLOps Manager',
					subtitle: 'Settings',
				},
			},
		],
	},
];

export const MLOPS_MANAGER_MODULE: Module = {
	id: PAGES.HOME,
	link: { name: PAGES.MODELS_LIST },
	title: 'MLOps Manager',
	icon: shallowRef(ModuleIcon),
	enabled: ({ canAccessMLOpsManager }) => canAccessMLOpsManager,
	routes,
};
